import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function WhatYouGetSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-14 md:py-24 px-6 relative" style={{
    background: '#0D1B2A'
  }} data-id="element-356">
      <div className="max-w-4xl mx-auto" data-id="element-357">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-358">
          <div className="amber-divider mb-8 md:mb-12" data-id="element-359" />

          <h2 className="text-2xl md:text-4xl font-bold text-center mb-10 md:mb-16" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-360">
            Ce que tu reçois
          </h2>

          <div className="space-y-6 md:space-y-8" data-id="element-361">
            {/* Main Product */}
            <div className="p-8 rounded-2xl relative overflow-hidden" style={{
            background: '#162030',
            border: '2px solid rgba(212,168,83,0.3)'
          }} data-id="element-362">
              <div className="absolute top-0 right-0 px-4 py-1 rounded-bl-xl text-sm font-bold" style={{
              background: '#D4A853',
              color: '#0D1B2A',
              fontFamily: 'DM Sans, sans-serif'
            }} data-id="element-363">
                Valeur : 97 $
              </div>
              <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-364">
                <img src="https://cdn.magicpatterns.com/uploads/f1mEKJ83Ddc4NZENURTd4G/COVER_LA_METHODE_OFF.png" alt="La Méthode OFF — 10 Minutes pour Retrouver le Silence Mental" className="w-48 md:w-56 rounded-xl flex-shrink-0" style={{
                boxShadow: '0 10px 30px rgba(0,0,0,0.4)'
              }} data-id="element-365" />
                <div data-id="element-366">
                  <h3 className="text-2xl font-bold mb-4 mt-2" style={{
                  fontFamily: 'Playfair Display, serif',
                  color: '#D4A853'
                }} data-id="element-367">
                    📖 LA MÉTHODE OFF
                  </h3>
                  <p className="text-lg mb-6" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#F5F0E8'
                }} data-id="element-368">
                    Le protocole complet des 10 minutes.
                  </p>
                  <ul className="space-y-3 mb-8" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-369">
                    <li className="flex items-start gap-3" data-id="element-370">
                      <span className="text-amber-500" data-id="element-371">✓</span> Le Brain Dump
                      chirurgical.
                    </li>
                    <li className="flex items-start gap-3" data-id="element-372">
                      <span className="text-amber-500" data-id="element-373">✓</span> Le système du
                      Cerveau Externe.
                    </li>
                    <li className="flex items-start gap-3" data-id="element-374">
                      <span className="text-amber-500" data-id="element-375">✓</span> Le menu cyclique
                      anti-stress.
                    </li>
                    <li className="flex items-start gap-3" data-id="element-376">
                      <span className="text-amber-500" data-id="element-377">✓</span> Le guide pour
                      mamans solos.
                    </li>
                    <li className="flex items-start gap-3" data-id="element-378">
                      <span className="text-amber-500" data-id="element-379">✓</span> Le plan des 30
                      premiers jours.
                    </li>
                  </ul>
                  <p className="italic font-medium" style={{
                  fontFamily: 'Playfair Display, serif',
                  color: '#D4A853'
                }} data-id="element-380">
                    Tu lis. Tu appliques ce soir. Tu ressens la différence
                    demain.
                  </p>
                </div>
              </div>
            </div>

            {/* Bonus 1 */}
            <div className="p-8 rounded-2xl relative overflow-hidden" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-381">
              <div className="absolute top-0 right-0 px-4 py-1 rounded-bl-xl text-sm font-bold opacity-80" style={{
              background: 'rgba(212,168,83,0.2)',
              color: '#D4A853',
              fontFamily: 'DM Sans, sans-serif'
            }} data-id="element-382">
                Valeur : 27 $
              </div>
              <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-383">
                <img src="https://cdn.magicpatterns.com/uploads/i8uZ1ir8zHxDWAWEnUCuXD/COVER_BONUS_1.png" alt="Bonus 1 : Le Kit de Survie du Dimanche Soir" className="w-40 md:w-48 rounded-xl flex-shrink-0" style={{
                boxShadow: '0 10px 30px rgba(0,0,0,0.4)'
              }} data-id="element-384" />
                <div data-id="element-385">
                  <h3 className="text-xl font-bold mb-4 mt-2" style={{
                  fontFamily: 'Playfair Display, serif',
                  color: '#F5F0E8'
                }} data-id="element-386">
                    🛟 BONUS 1 : Le Kit de Survie du Dimanche Soir
                  </h3>
                  <p className="mb-6" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-387">
                    La routine exacte pour transformer le moment le plus
                    stressant de ta semaine en calme total.
                  </p>
                  <ul className="space-y-2 text-sm" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-388">
                    <li data-id="element-389">• La checklist des 15 points.</li>
                    <li data-id="element-390">• La technique du Gros Caillou.</li>
                    <li data-id="element-391">• Le protocole d'extinction à 20h.</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="p-8 rounded-2xl relative overflow-hidden" style={{
            background: '#162030',
            border: '1px solid rgba(212,168,83,0.15)'
          }} data-id="element-392">
              <div className="absolute top-0 right-0 px-4 py-1 rounded-bl-xl text-sm font-bold opacity-80" style={{
              background: 'rgba(212,168,83,0.2)',
              color: '#D4A853',
              fontFamily: 'DM Sans, sans-serif'
            }} data-id="element-393">
                Valeur : 27 $
              </div>
              <div className="flex flex-col md:flex-row gap-6 items-center" data-id="element-394">
                <img src="https://cdn.magicpatterns.com/uploads/6hn5jvV8Hh8QKm3jzmUoE6/COVER_BONUS_2.png" alt="Bonus 2 : Dashboard Digital" className="w-40 md:w-48 rounded-xl flex-shrink-0" style={{
                boxShadow: '0 10px 30px rgba(0,0,0,0.4)'
              }} data-id="element-395" />
                <div data-id="element-396">
                  <h3 className="text-xl font-bold mb-4 mt-2" style={{
                  fontFamily: 'Playfair Display, serif',
                  color: '#F5F0E8'
                }} data-id="element-397">
                    📱 BONUS 2 : Le Dashboard Digital
                  </h3>
                  <p className="mb-6" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#C8C0B0'
                }} data-id="element-398">
                    Ton Cerveau Externe prêt sur ton téléphone en moins de 20
                    minutes.
                  </p>
                  <ul className="space-y-2 text-sm" style={{
                  fontFamily: 'DM Sans, sans-serif',
                  color: '#8A8070'
                }} data-id="element-399">
                    <li data-id="element-400">
                      • Templates Notion et Google Calendar déjà configurés.
                    </li>
                    <li data-id="element-401">• Tu copies. Tu colles. Tu utilises.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}